import { axiosClient, buildQuery } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { BucketFile } from '@nx-frontend/shared/types';
import { GetWorkspaceOptions } from '@nx-frontend/shared/types';

export interface GetWorkspaceFilesParams {
  workspaceId: string;
  attachmentIds?: string[];
  limitSize?: number;
  limitFrom?: number;
  resetCache?: string;
}

export async function getWorkspaceFiles(
  { workspaceId, attachmentIds, ...params }: GetWorkspaceFilesParams,
  options: GetWorkspaceOptions
): Promise<BucketFile[]> {
  const { userId } = options;
  let files: BucketFile[] = [];

  try {
    const query = buildQuery({
      workspaceId,
      sortField: 'createdAt',
      sortOrder: 'desc',
      userId,
      ...params,
      ...(attachmentIds ? { attachmentIds: attachmentIds.join(',') } : {}),
    });

    const { data } = await axiosClient.get(`${generalEnv.bucketServiceUrl}/v1/files?${query}`, {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    });

    files = data;
  } catch (err) {
    console.error(`getWorkspace error: ${err}`);
  }

  return files;
}
